// PRODUCT-TAB-BLOCK
document.addEventListener('DOMContentLoaded', () => {
  // Find ALL view-all buttons (one per section)
  const viewAllButtons = document.querySelectorAll('.viewallbtn.dynamic-viewall');

  viewAllButtons.forEach((viewAllButton) => {
    // Find the closest product-tab section container for this button
    const sectionContainer = viewAllButton.closest('.halo-product-block, .product-tab-block, .section-block');

    if (!sectionContainer) return;

    // Only look for tabs/buttons inside THIS section
    const tabButtons = sectionContainer.querySelectorAll('.list-product-tabs .tab-links');

    const updateViewAllHref = () => {
      const activeTab = sectionContainer.querySelector('.list-product-tabs .tab-links.active');
      if (activeTab && viewAllButton) {
        const href = activeTab.getAttribute('data-href').replace('?view=ajax_product_block', '');
        viewAllButton.setAttribute('href', href);
      }
    };

    // Run once on load
    updateViewAllHref();

    // Listen to clicks inside this section only
    tabButtons.forEach(button => {
      button.addEventListener('click', updateViewAllHref);
    });

    // Observe class changes only on tabs inside this section
    const observer = new MutationObserver(updateViewAllHref);
    tabButtons.forEach(button => {
      observer.observe(button, { attributes: true, attributeFilter: ['class'] });
    });

    // Optional: store per-section if you need cleanup later
    // sectionContainer.__tabObserver = observer;
  });
});

// COLLECTION-PRODUCT-GRID


document.addEventListener('DOMContentLoaded', () => {
  const sidebar = document.getElementById('halo-sidebar');
  const pageContent = document.querySelector('.page-sidebar + .page-content');
  
  const hideBtn   = document.getElementById('hide-sidebar-btn');
  const restoreBtn = document.getElementById('restore-sidebar-btn');

  // Common breakpoint in many Shopify themes (Dawn uses ~750px, others 749/767)
  const isMobile = window.innerWidth <= 749 || window.matchMedia("(max-width: 749px)").matches;

  let isSidebarVisible = !isMobile;  // mobile: false (hidden), desktop: true (visible)

  // Set initial mobile state
  if (isMobile) {
    sidebar.style.display = 'none';
    pageContent.classList.add('full-width');
    restoreBtn.style.display = 'flex';
    // hideBtn remains in DOM – will appear when sidebar is shown
  } else {
    restoreBtn.style.display = 'none';
  }

  // Hide sidebar (works on both desktop and mobile when sidebar is visible)
  hideBtn?.addEventListener('click', () => {
    sidebar.style.display = 'none';
    pageContent.classList.add('full-width');
    restoreBtn.style.display = 'flex';
    isSidebarVisible = false;
  });

  // Restore sidebar (mainly for mobile, but works everywhere)
  restoreBtn?.addEventListener('click', () => {
    sidebar.style.display = 'block';
    pageContent.classList.remove('full-width');
    restoreBtn.style.display = 'none';
    isSidebarVisible = true;
  });
});


// TOOLBAR .LIQUID
document.addEventListener('DOMContentLoaded', function() {
  const countersrise = document.querySelectorAll('.counterrise');
  
  function startCountingrise(element) {
    let start = 0;
    const end = parseInt(element.getAttribute('data-count')) || 0;
    const duration = 2000;
    const range = end - start;
    let current = start;
    const increment = end > start ? 1 : -1;
    const stepTime = Math.abs(Math.floor(duration / range)) || 1;
    
    const timer = setInterval(() => {
      current += increment;
      element.textContent = current;
      if (current === end) clearInterval(timer);
    }, stepTime);
    
    element.classList.add('animaterise');
  }

  function checkCountersrise() {
    countersrise.forEach(counterrise => {
      const rect = counterrise.getBoundingClientRect();
      if (rect.top <= window.innerHeight && rect.bottom >= 0 && !counterrise.classList.contains('animaterise')) {
        startCountingrise(counterrise);
      }
    });
  }

  // Save reference for cleanup
  window.__counterScrollHandler = checkCountersrise;
  window.addEventListener('scroll', checkCountersrise);
  checkCountersrise();
});

// HALO-QUICK-VIEW-SLICK SLIDER
// HALO-QUICK-VIEW-SLICK SLIDER
// HALO-QUICK-VIEW-SLICK SLIDER
let quickzerObserver = null;

function initquickzer(quickzer) {
    let isDown = false;
    let startX;
    let scrollLeft;
    const sensitivity = 1.5;

    function removeEventListeners() {
        quickzer.removeEventListener('mousedown', handleStart);
        quickzer.removeEventListener('mouseleave', handleEnd);
        quickzer.removeEventListener('mouseup', handleEnd);
        quickzer.removeEventListener('mousemove', handleMove);
    }

    function handleStart(e) {
        isDown = true;
        quickzer.classList.add('grabbing');
        startX = e.pageX - quickzer.offsetLeft;
        scrollLeft = quickzer.scrollLeft;
    }

    function handleEnd() {
        isDown = false;
        quickzer.classList.remove('grabbing');
    }

    function handleMove(e) {
        if (!isDown) return;
        e.preventDefault();
        const x = e.pageX - quickzer.offsetLeft;
        const walk = (x - startX) * sensitivity;
        quickzer.scrollLeft = scrollLeft - walk;
    }

    removeEventListeners();
    quickzer.addEventListener('mousedown', handleStart);
    quickzer.addEventListener('mouseleave', handleEnd);
    quickzer.addEventListener('mouseup', handleEnd);
    quickzer.addEventListener('mousemove', handleMove);
}

function isDesktopView() {
    return window.innerWidth > 768;
}

if (isDesktopView()) {
    quickzerObserver = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
            if (mutation.addedNodes.length) {
                mutation.addedNodes.forEach((node) => {
                    if (node.nodeType === Node.ELEMENT_NODE) {
                        const quickzers = node.querySelectorAll('.quickzer-container');
                        quickzers.forEach((quickzer) => {
                            if (!quickzer.dataset.initialized) {
                                initquickzer(quickzer);
                                quickzer.dataset.initialized = 'true';
                            }
                        });
                    }
                });
            }
        });
    });

    const quickViewContainer = document.querySelector('.halo-quick-view-popup') || document.body;
    quickzerObserver.observe(quickViewContainer, { childList: true, subtree: true });

    const quickzers = document.querySelectorAll('.quickzer-container');
    quickzers.forEach((quickzer) => {
        if (!quickzer.dataset.initialized) {
            initquickzer(quickzer);
            quickzer.dataset.initialized = 'true';
        }
    });
}

// CLEANUP: Remove all global listeners and observers on page unload
window.addEventListener('beforeunload', () => {
  // Product Tab Observer
  window.__productTabObserver?.disconnect();

  // Counter Scroll
  if (window.__counterScrollHandler) {
    window.removeEventListener('scroll', window.__counterScrollHandler);
    window.__counterScrollHandler = null;
  }

  // quickzer Observer
  quickzerObserver?.disconnect();
});


// =========================================THEME.LIQUID JS



  /////////////START SCRIPT
  document.addEventListener('DOMContentLoaded', function() {
    const quickShopSwatches = document.querySelectorAll('.variants-popup-content .swatch-element');
    
    quickShopSwatches.forEach(swatch => {
      swatch.addEventListener('click', function() {
        const variantImg = this.getAttribute('data-variant-img');
        const productId = this.closest('.variants-popup-content').querySelector('form').dataset.id.replace('product-actions-', '');
        const productCard = document.querySelector(`.product-item[data-product-id="${productId}"]`);
        
        if (variantImg && productCard) {
          const cardImage = productCard.querySelector('.card-media img');
          if (cardImage) {
            cardImage.src = variantImg;
            cardImage.srcset = variantImg; // Update srcset for responsive images
          }
        }
      });
    });
  });
/////////////END SCRIPT



let rippleObserver = null;

function initRippleObserver() {
  if (rippleObserver) return;

  rippleObserver = new MutationObserver(() => {
    document.querySelectorAll('.rip-btn:not([data-ripple])').forEach(btn => {
      btn.dataset.ripple = 'true';
      btn.addEventListener('click', rippleHandler);
    });
  });

  rippleObserver.observe(document.body, { childList: true, subtree: true });
}

// Run once
document.addEventListener('DOMContentLoaded', () => {
  initRippleObserver();
});

// Cleanup
window.addEventListener('beforeunload', () => {
  if (rippleObserver) {
    rippleObserver.disconnect();
    rippleObserver = null;
  }
});

// Your original handler
function rippleHandler(e) {
  let x = e.offsetX;
  let y = e.offsetY;
  const ripple = document.createElement('span');
  ripple.classList.add('ripple');
  ripple.style.setProperty('--mouse-x', x + 'px');
  ripple.style.setProperty('--mouse-y', y + 'px');
  this.appendChild(ripple);
  setTimeout(() => ripple.classList.add('fade-out'), 0);
  setTimeout(() => ripple.remove(), 3000);
}




/*
<script>
  // Handle add-to-cart events
$(document).on('click', '[data-btn-addtocart]', function(e) {
    e.preventDefault();
    var $this = $(this);
    var $form = $this.closest('form');
    
    var variantId = $form.find('[name="id"]').val();
    var quantity = parseInt($form.find('[name="quantity"]').val()) || 1;
    var size = $form.find('input[name="properties[Size]"]:checked').val() || '';

    var payload = { id: variantId, quantity: quantity };
    if (size) payload.properties = { Size: size };

    $.ajax({
        type: 'POST',
        url: '/cart/add.js',
        data: JSON.stringify(payload),
        contentType: '',
        success: function() {
            updateCartTotal();
            document.dispatchEvent(new Event('cart:updated'));
        }
    });
});
</script>*/




document.addEventListener('click', e => {
  const btn = e.target.closest('[data-open-edit-cart]');
  if (!btn) return;

  const line = btn.dataset.line;
  const observer = new MutationObserver(() => {
    const item = document.querySelector('.product-edit-item');
    if (item) {
      item.dataset.line = line;
      observer.disconnect();
    }
  });
  observer.observe(document.body, { childList: true, subtree: true });
});








    document.querySelectorAll('.scrollable-title').forEach(el => {
    let isDown = false;
    let startX;
    let scrollLeft;

    // Mouse drag
    el.addEventListener('mousedown', e => {
      isDown = true;
      el.classList.add('active');
      startX = e.pageX - el.offsetLeft;
      scrollLeft = el.scrollLeft;
    });

    el.addEventListener('mouseleave', () => {
      isDown = false;
      el.classList.remove('active');
    });

    el.addEventListener('mouseup', () => {
      isDown = false;
      el.classList.remove('active');
    });

    el.addEventListener('mousemove', e => {
      if (!isDown) return;
      e.preventDefault();
      const x = e.pageX - el.offsetLeft;
      const walk = (x - startX) * 2; // Multiply for speed
      el.scrollLeft = scrollLeft - walk;
    });

    // Bonus: Horizontal scroll with vertical wheel (Shift + Wheel or natural)
    el.addEventListener('wheel', e => {
      if (e.deltaY !== 0) {
        el.scrollLeft += e.deltaY;
        e.preventDefault(); // Prevent page scroll
      }
    });
  });








  // ←←← FINAL VERSION – copy-paste this exactly
let startY = 0;
const cart = document.getElementById('halo-cart-sidebar');
const closeBtn = document.querySelector('[data-close-cart-sidebar]');

cart.addEventListener('touchstart', e => {
  if (e.target.closest('.swipe-handle')) {
    startY = e.touches[0].clientY;
  }
}, { passive: true });

cart.addEventListener('touchmove', e => {
  if (!startY) return;
  const currentY = e.touches[0].clientY;
  const pulledDown = currentY - startY;

  // Optional: tiny visual feedback (rubber-band effect)
  if (pulledDown > 0) {
    cart.style.transform = `translateY(${Math.min(pulledDown * 0.3, 80)}px)`; // very subtle
  }
  e.preventDefault();
}, { passive: false });

cart.addEventListener('touchend', () => {
  if (!startY) return;

  const pulledDown = event.changedTouches[0].clientY - startY;

  // Remove any temporary transform
  cart.style.transform = '';

  if (pulledDown > 140) {
    // Simply click your real close button → Halo handles everything perfectly
    closeBtn.click();
  }

  startY = 0;
});







/*
<script>
// STAND-ALONE LEFT MENU – SWIPE LEFT TO CLOSE (co-exists with cart pull-down)
// Works on any Halo theme menu that slides in from the left
(() => {
  let startX = 0;
  const menu = document.querySelector('.halo-sidebar.halo-sidebar_menu');
  if (!menu) return; // safety

  const closeButtons = menu.querySelectorAll('[data-menu-close-sidebar]');
  const closeMenu = () => closeButtons.forEach(btn => btn.click());

  menu.addEventListener('touchstart', e => {
    if (e.target.closest('.swipe-handle') || e.target.closest('.halo-sidebar-header')) {
      startX = e.touches[0].clientX;
    }
  }, { passive: true });

  menu.addEventListener('touchmove', e => {
    if (!startX) return;
    const currentX = e.touches[0].clientX;
    const pulledLeft = startX - currentX; // positive = swiped left

    // Optional subtle rubber-band feedback while dragging
    if (pulledLeft > 0) {
      menu.style.transform = `translateX(-${Math.min(pulledLeft * 0.4, 100)}px)`;
    }
    e.preventDefault();
  }, { passive: false });

  menu.addEventListener('touchend', () => {
    if (!startX) return;

    const pulledLeft = startX - event.changedTouches[0].clientX;

    // Clean up any temporary transform
    menu.style.transform = '';

    if (pulledLeft > 130) {
      closeMenu(); // triggers your exact existing close button → perfect Halo animation
    }

    startX = 0;
  });
})();
</script>
*/









/////////////////////////////// PRODUCT CARD COLOR NAME FOR MOBILE///////////////////
document.querySelectorAll('.card-swatch .swatch-label').forEach(label => {
  const card = label.closest('.card-wrapper') || 
               label.closest('.grid__item') || 
               label.closest('.product-card') || 
               label.closest('[data-product-id]');

  if (!card) return;

  const overlay = card.querySelector('.color-name-overlay');
  if (!overlay) return;

  // Show color name on touch/tap (mobile)
  label.addEventListener('touchstart', (e) => {
    if (window.innerWidth <= 3000) {
      overlay.textContent = label.dataset.colorName;
      overlay.style.opacity = '1'; // Show (fades in due to transition)
    }
  });

  // Handle mouse click
  label.addEventListener('click', (e) => {
    if (window.innerWidth <= 3000) {
      overlay.textContent = label.dataset.colorName;
      overlay.style.opacity = '1'; // Show

      // Auto-fade-out after 4 seconds
      clearTimeout(overlay.hideTimeout);
      overlay.hideTimeout = setTimeout(() => {
        overlay.style.opacity = '0'; // Fade out
      }, 1800);
    }
  });
});









document.addEventListener('DOMContentLoaded', function() {
  const countersrise = document.querySelectorAll('.counterrise');
  
  function startCountingrise(element) {
    const end = parseInt(element.getAttribute('data-count'), 10);
    const duration = 2000; // 2 seconds
    let start = 0;

    // === SPECIAL CASE: If count is 0, set immediately and exit ===
    if (end === 0 || isNaN(end) || end < 0) {
      element.textContent = '0';
      element.classList.add('animaterise');
      return;
    }

    const range = end - start;
    const increment = range > 0 ? 1 : -1;
    
    // Prevent division by zero and extreme step times
    let stepTime = Math.abs(Math.floor(duration / range));
    stepTime = stepTime < 1 ? 1 : (stepTime > 100 ? 100 : stepTime); // Clamp between 1ms and 100ms

    let current = start;
    const timer = setInterval(() => {
      current += increment;
      element.textContent = current;

      // Stop when we reach the target
      if (current === end) {
        clearInterval(timer);
      }
    }, stepTime);

    element.classList.add('animaterise'); // Apply animation class
  }

  function checkCountersrise() {
    countersrise.forEach(counterrise => {
      const rect = counterrise.getBoundingClientRect();
      const isInViewport = rect.top <= window.innerHeight && rect.bottom >= 0;
      
      if (isInViewport && !counterrise.classList.contains('animaterise')) {
        startCountingrise(counterrise);
      }
    });
  }

  // Run on scroll and on initial load
  window.addEventListener('scroll', checkCountersrise);
  checkCountersrise();
});











const QUICK_VIEW_SELECTOR = '.halo-popup.halo-quick-view-popup.customPopup-large';
const ELEVATED_Z = '106';
const SIDE_CART_BODY_CLASS = 'cart-sidebar-show';

function forceElevatedZ(modal) {
  if (!modal) return;
  modal.style.setProperty('z-index', ELEVATED_Z, 'important');
}

function setupZIndexFix() {
  // Only run when quick view is triggered via known buttons
  document.addEventListener('click', function(e) {
    const trigger = e.target.closest('.previewCart-wrapper button, .previewCart-wrapper [data-open-quick-view-popup]');
    if (!trigger) return;
    if (!document.body.classList.contains(SIDE_CART_BODY_CLASS)) return;

    // Wait a short delay for popup to render (theme timing)
    setTimeout(() => {
      const modal = document.querySelector(QUICK_VIEW_SELECTOR);
      if (!modal) return;

      // Apply z-index immediately
      forceElevatedZ(modal);

      // Use MutationObserver instead of polling – only reacts to changes
      const observer = new MutationObserver((mutations) => {
        mutations.forEach(() => {
          if (document.body.contains(modal) && 
              modal.offsetParent !== null && 
              !modal.classList.contains('hidden') && 
              getComputedStyle(modal).display !== 'none' &&
              document.body.classList.contains(SIDE_CART_BODY_CLASS)) {
            forceElevatedZ(modal);
          }
        });
      });

      observer.observe(modal, { 
        attributes: true, 
        attributeFilter: ['style', 'class', 'hidden'],
        subtree: true,
        childList: true 
      });

      // Cleanup function
      const cleanup = () => {
        observer.disconnect();
        modal?.style.removeProperty('z-index');
      };

      // Attach cleanup to close buttons (Halo selectors)
      modal.querySelectorAll('.close, [data-close], .halo-popup__close, button[aria-label*="close"], .overlay').forEach(el => {
        el.addEventListener('click', cleanup, { once: true });
      });

      // ESC key cleanup
      const escHandler = ev => {
        if (ev.key === 'Escape') cleanup();
      };
      document.addEventListener('keydown', escHandler, { once: true });

      // Safety timeout (e.g. 60s) in case close events miss
      setTimeout(cleanup, 60000);

      // Also cleanup if cart sidebar closes
      const cartCloseObserver = new MutationObserver(() => {
        if (!document.body.classList.contains(SIDE_CART_BODY_CLASS)) {
          cleanup();
          cartCloseObserver.disconnect();
        }
      });
      cartCloseObserver.observe(document.body, { attributes: true, attributeFilter: ['class'] });

    }, 250); // keep the original delay for theme render timing

  }, true); // capture phase
}

// Run once on page load
setupZIndexFix();







document.addEventListener('DOMContentLoaded', function() {
  const toggleBtn = document.querySelector('.simple-cart-toggle');
  const cartIcon = toggleBtn?.querySelector('.cart-icon');
  const closeIcon = toggleBtn?.querySelector('.close-icon');

  if (!toggleBtn || !cartIcon || !closeIcon) return;

  function isOpen() {
    return document.body.classList.contains('cart-sidebar-show');
  }

  function updateIcon() {
    if (isOpen()) {
      cartIcon.style.opacity = '0';
      closeIcon.style.opacity = '1';
    } else {
      cartIcon.style.opacity = '1';
      closeIcon.style.opacity = '0';
    }
  }

  // Prevent any external script from disabling the button visually
  const buttonObserver = new MutationObserver(() => {
    if (toggleBtn.hasAttribute('disabled')) {
      toggleBtn.removeAttribute('disabled');
    }
  });
  buttonObserver.observe(toggleBtn, { attributes: true, attributeFilter: ['disabled'] });

  // Initial state
  updateIcon();

  // Click
  toggleBtn.addEventListener('click', function(e) {
    // If theme JS prevents default or disables, counteract it
    document.body.classList.toggle('cart-sidebar-show');
    updateIcon();
  });

  // Sync with other triggers
  const bodyObserver = new MutationObserver(updateIcon);
  bodyObserver.observe(document.body, { attributes: true, attributeFilter: ['class'] });
});